import { SEARCHTEAM_FAIL, SEARCHTEAM_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const searchTeamReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCHTEAM_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SEARCHTEAM_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default searchTeamReducer;
